module.exports = __webpack_public_path__ + "static/media/Click Report.6f8bb4d9.jpg";